import React, { useState, useEffect } from "react";
import { Routes, Route, Link, Navigate, useLocation } from "react-router-dom";
import { IoClose, IoMenu } from "react-icons/io5";
import DailyReport from "./DailyReports/DailyReport";
import BackDatedReport from "./BackDatedReport/BackDatedReport";
import FoodItemSale from "./Reports/FoodItemSale";
import BarItemSale from "./Reports/BarItemSale";
import ItemCncl from "./Reports/ItemCncl";
import ChoiceItem from "./Reports/ChoiceItem";
import OpenRateItem from "./Reports/OpenRateItem";
import LocationwiseSale from "./Reports/LocationwiseSale";
import BarPurchase from "./Reports/BarPurchase";
import BarBalance from "./Reports/BarBalance";


const ReportsDashbord = () => {
  const [selectedLabel, setSelectedLabel] = useState("Reports Dashboard");
  const location = useLocation();
  const [isSidebarVisible, setSidebarVisible] = useState(true);

  // Define the button routes here
  const AccountsUserButton = [
    { label: "Daily Report", path: "DailyReport" },
    { label: "Back Dated Report", path: "BackDatedReport" },
    { label: "FoodItem Sale", path: "FoodItemSale" },
    { label: "BarItem Sale", path: "BarItemSale" },
    { label: "Item Cancle", path: "ItemCncl" },
    { label: "Choice Item", path: "ChoiceItem" },
    { label: "OpenRate Item", path: "OpenRateItem" },
    { label: "LocationWise Sale", path: "LocationWiseSale" },
    { label: "Bar Purchase", path: "BarPurchase" },
    { label: "Bar Balance", path: "BarBalance" },
    // Add more buttons for other pages like SwiggyNewOrder, etc.
  ];

  // Update the selected label based on the current route
  useEffect(() => {
    const currentPathSegment = location.pathname.split("/").pop();
    const currentButton = AccountsUserButton.find(
      (button) => button.path === currentPathSegment
    );
    if (currentButton) {
      setSelectedLabel(currentButton.label);
    }
  }, [location.pathname]);

  // Handler for hiding sidebar when a button is clicked
  const handleButtonClick = () => setSidebarVisible(false);

  // Toggle sidebar visibility
  const toggleSidebar = () => setSidebarVisible(!isSidebarVisible);

  return (
    <>
      {/* Navbar */}
      <nav className="navbar shadow p-3 bg-body rounded navbar-light bg-light d-flex align-items-center">
        <span className="navbar-brand mb-0 h1">
          <i>BillTrace</i> Reports
        </span>
        <h5 className="ms-auto">{selectedLabel}</h5>
        {/* Sidebar toggle button */}
        {isSidebarVisible ? (
          <IoClose
            className="sidebar-toggle-icon ms-auto"
            onClick={toggleSidebar}
          />
        ) : (
          <IoMenu
            className="sidebar-toggle-icon ms-auto"
            onClick={toggleSidebar}
          />
        )}
      </nav>

      {/* Sidebar & Main Content */}
      <div className="d-flex">
        {/* Sidebar */}
        <div className={`sidebar ${isSidebarVisible ? "open" : ""}`}>
          <div className="button-container mt-2">
            {AccountsUserButton.map((button, index) => (
              <Link
                key={index}
                to={`/ReportsDashboard/${button.path}`} // Absolute path within the dashboard
                className="btn btn-primary mb-2 MasterCreationButtons"
                onClick={handleButtonClick}
              >
                {button.label}
              </Link>
            ))}
          </div>
        </div>

        {/* Main Content */}
        <div className="main-content">
          <Routes>
            {/* Redirect to /ReportsDashboard/DailyReport if no route matches */}
            <Route path="/" element={<Navigate to="/ReportsDashboard/DailyReport" replace />} />
            {/* Add the routes for each page inside the dashboard */}
            <Route path="/DailyReport" element={<DailyReport />} />
            <Route path="/BackDatedReport" element={<BackDatedReport />} />
            <Route path="/FoodItemSale" element={<FoodItemSale />} />
            <Route path="/BarItemSale" element={<BarItemSale />} />
            <Route path="/ItemCncl" element={<ItemCncl />} />
            <Route path="/ChoiceItem" element={<ChoiceItem />} />
            <Route path="/OpenRateItem" element={<OpenRateItem />} />
            <Route path="/LocationWiseSale" element={<LocationwiseSale />} />
            <Route path="/BarPurchase" element={<BarPurchase />} />
            <Route path="/BarBalance" element={<BarBalance />} />

            {/* You can add more child routes here */}
          </Routes>
        </div>
      </div>
    </>
  );
};

export default ReportsDashbord;
